import gql from 'graphql-tag';

const UPDATE_CONFIRM_CHECKLIST_POPUP = gql`
  mutation UpdateMystageConfirmChecklistPopup($lesson_id: Int, $hide_modal: Int) {
    mystage_confirm_checklist_popup(lesson_id: $lesson_id, hide_modal: $hide_modal) {
      ok
    }
  }
`;

const UPDATE_CONFIRM_CHECKLIST_POPUP_MSB = gql`
  mutation UpdateMystageConfirmChecklistPopup($lesson_id: Int, $hide_modal: Int) {
    mystageConfirmChecklistPopup(student_book_id: $lesson_id, hide_modal: $hide_modal) {
      ok
    }
  }
`;

export { 
  UPDATE_CONFIRM_CHECKLIST_POPUP,
  UPDATE_CONFIRM_CHECKLIST_POPUP_MSB 
};
